import { c as _c } from "react/compiler-runtime";
import React, { Fragment, useState, type JSX } from 'react';
import { ActionMenu } from 'shared/components';
import Confirmation from 'shared/components/confirmation-modal';
import EditModal from 'shared/components/edit-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getDataTestAttributes } from 'shared/utils/get-data-test-attributes';
import { twMerge } from 'tailwind-merge';
import { actionMenuLinkItem } from '../action-menu-link-item';
import { ActionsInterface, ActionsRenderProps, CustomStateType } from './types';
export function ActionsRender(t0) {
  const $ = _c(43);
  const {
    actions,
    instance,
    caption,
    actionsTitle,
    testAttributePostfix,
    actionsOrder,
    rowId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isActivateOpen, setIsActivateOpen] = useState(false);
  const [confirmingInstance, setConfirmingInstance] = useState(instance);
  const [isRemoveOpen, setIsRemoveOpen] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  let t1;
  if ($[0] !== actions.custom) {
    t1 = () => {
      const obj = {} as CustomStateType<T>;
      actions.custom?.forEach(value => {
        obj[value.name] = false;
      });
      return obj;
    };
    $[0] = actions.custom;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [isCustomOpen, setIsCustomOpen] = useState(t1);
  let actionSideElements;
  let t2;
  if ($[2] !== actions.activate || $[3] !== actions.custom || $[4] !== actions.edit || $[5] !== actions.openLink || $[6] !== actions.remove || $[7] !== actions.settings || $[8] !== actionsOrder || $[9] !== caption || $[10] !== confirmingInstance || $[11] !== instance || $[12] !== isActivateOpen || $[13] !== isCustomOpen || $[14] !== isRemoveOpen || $[15] !== isSettingsOpen || $[16] !== rowId || $[17] !== t || $[18] !== testAttributePostfix) {
    actionSideElements = [];
    const openLinkRender = () => {
      if (actions.openLink) {
        return actions.openLink.map(el => {
          const shouldRender = el.shouldRender ? el.shouldRender(instance) : true;
          if (shouldRender) {
            return actionMenuLinkItem({
              isNext: el.isNext,
              openInNew: el.openInNew,
              dataTestAttributes: getDataTestAttributes(!!testAttributePostfix, `option-link-${el.name}-${rowId}`),
              id: `${el.name}-open-link`,
              href: el.setHref(instance),
              label: el.caption ? el.caption : t("dashboard.actions.title.open")
            });
          }
        });
      }
    };
    const customRender = () => {
      if (actions.custom) {
        return actions.custom.map(el_0 => {
          const shouldRender_0 = el_0.shouldRender ? el_0.shouldRender(instance) : true;
          const key = `${el_0.name}-modal`;
          const customActionRender = el_0.onActionRender ? el_0.onActionRender(isCustomOpen?.[el_0.name] || false, () => setIsCustomOpen(prev => ({
            ...prev,
            [el_0.name]: false
          })), instance, key) : undefined;
          if (shouldRender_0) {
            customActionRender && actionSideElements.push(<Fragment key={key}>{customActionRender}</Fragment>);
            const itemProps = {
              id: `${el_0.name}-custom`,
              dataTestAttributes: getDataTestAttributes(!!testAttributePostfix, `option-${el_0.name}-${rowId}`),
              onClick: async () => {
                setIsCustomOpen(prev_0 => ({
                  ...prev_0,
                  [el_0.name]: true
                }));
                if (el_0.onActionClick) {
                  ;
                  try {
                    setIsFetching(true);
                    await el_0.onActionClick(instance);
                    setIsFetching(false);
                  } catch (t3) {
                    setIsFetching(false);
                  }
                }
              },
              label: el_0.caption,
              disabled: el_0.disabled
            };
            return el_0.CustomActionMenuItem ? el_0.CustomActionMenuItem(itemProps) : itemProps;
          }
        });
      }
    };
    const settingsRender = () => {
      if (actions.settings) {
        const settings = actions.settings;
        const shouldRender_1 = actions.settings.shouldRender ? actions.settings.shouldRender(instance) : true;
        if (shouldRender_1) {
          actionSideElements.push(<EditModal key="settings-modal" opened={isSettingsOpen} onOpen={settings.onModalOpen} isPreFetching={settings.isFetching} onClose={() => {
            setIsSettingsOpen(false);
          }} fullCaption={settings.fullCaption} afterLeave={settings.onModalClose} caption={caption} editable={settings.editable} instance={instance} additionalData={settings.additionalData} onEdit={data => settings.onEdit(instance, data)} toastCaption={settings.toastCaption ? settings.toastCaption : t("dashboard.actions.updated", {
            module: caption
          })} />);
          return {
            id: "action-settings",
            onClick: () => {
              setIsSettingsOpen(true);
            },
            label: t("dashboard.actions.title.settings"),
            dataTestAttributes: getDataTestAttributes(!!testAttributePostfix, `option-settings-${rowId}`)
          };
        }
      }
    };
    const editRender = () => {
      if (actions.edit) {
        const shouldRender_2 = actions.edit.shouldRender ? actions.edit.shouldRender(instance) : true;
        const edit = actions.edit;
        if (shouldRender_2) {
          return actionMenuLinkItem({
            id: "action-edit",
            label: t("dashboard.actions.title.edit"),
            dataTestAttributes: getDataTestAttributes(!!testAttributePostfix, `option-link-${rowId}`),
            href: edit.setHref(instance),
            openInNew: edit.openInNew,
            isNext: edit.isNext
          });
        }
      }
    };
    const activateRender = () => {
      if (actions.activate) {
        const statusField = (actions.activate.customStatusField || "active") as keyof T;
        const isActive = instance[statusField];
        const activate = actions.activate;
        const shouldRender_3 = actions.activate.shouldRender ? actions.activate.shouldRender(instance) : true;
        const confirmationText = actions.activate.confirmationText ? actions.activate.confirmationText : "dashboard.actions.activate_confirmation";
        if (shouldRender_3) {
          const isDeactivating = Boolean(confirmingInstance[statusField]);
          actionSideElements.push(<Confirmation key="activate-modal" status={isDeactivating ? "error" : "normal"} confirmButtonCaption={isDeactivating ? t("global.deactivate") : t("global.activate")} opened={isActivateOpen} onClose={() => setIsActivateOpen(false)} onConfirm={() => activate.onChange(confirmingInstance)} confirmationText={t(confirmationText, {
            activate: isDeactivating ? t("global.deactivate").toLowerCase() : t("global.activate").toLowerCase(),
            module: caption?.toLowerCase()
          })} toastCaption={t("dashboard.actions.activated", {
            module: caption,
            activated: isDeactivating ? t("dashboard.actions.deactivated_caption").toLowerCase() : t("dashboard.actions.activated_caption").toLowerCase()
          })} />);
          const dataTestPostfix = isActive ? `option-deactivate-${rowId}` : `option-activate-${rowId}`;
          return {
            id: "action-activate",
            dataTestAttributes: getDataTestAttributes(!!testAttributePostfix, dataTestPostfix),
            onClick: () => {
              setConfirmingInstance(instance);
              setIsActivateOpen(true);
            },
            label: isActive ? t("dashboard.actions.title.deactivate") : t("dashboard.actions.title.activate")
          };
        }
      }
    };
    const removeRender = () => {
      if (actions.remove) {
        const remove = actions.remove;
        const shouldRender_4 = actions.remove.shouldRender ? actions.remove.shouldRender(instance) : true;
        if (shouldRender_4) {
          actionSideElements.push(<Confirmation status="error" key="remove-modal" opened={isRemoveOpen} onClose={() => setIsRemoveOpen(false)} onConfirm={() => remove.onChange(instance)} confirmationText={actions.remove.confirmationText ? actions.remove.confirmationText(instance) : t("dashboard.actions.remove_confirmation", {
            module: caption?.toLowerCase()
          })} title={actions.remove.confirmationTitle?.(instance)} toastCaption={actions.remove.showSuccessToast !== false && t("dashboard.actions.removed", {
            module: caption
          })} />);
          const itemProps_0 = {
            id: "action-remove",
            state: "destructive" as const,
            dataTestAttributes: getDataTestAttributes(!!testAttributePostfix, `option-remove-${rowId}`),
            onClick: () => {
              setIsRemoveOpen(true);
            },
            disabled: typeof remove.disabled === "function" ? remove.disabled(instance) : remove.disabled,
            label: actions.remove.CustomActionMenuItem ? undefined : t("dashboard.actions.title.remove")
          };
          return actions.remove.CustomActionMenuItem ? actions.remove.CustomActionMenuItem(itemProps_0, instance) : itemProps_0;
        }
      }
    };
    const getActionsToRender = () => {
      const actionsToRender = {
        openLink: openLinkRender,
        custom: customRender,
        settings: settingsRender,
        edit: editRender,
        activate: activateRender,
        remove: removeRender
      };
      const actionKeys = Object.keys(actionsToRender) as Array<keyof ActionsInterface<T, K>>;
      if (actionsOrder) {
        actionKeys.sort((a, b) => {
          const indexA = actionsOrder.indexOf(a);
          const indexB = actionsOrder.indexOf(b);
          return indexA - indexB;
        });
      }
      return actionKeys.map(key_0 => actionsToRender[key_0]);
    };
    t2 = getActionsToRender().flatMap(_temp).filter(_temp2);
    $[2] = actions.activate;
    $[3] = actions.custom;
    $[4] = actions.edit;
    $[5] = actions.openLink;
    $[6] = actions.remove;
    $[7] = actions.settings;
    $[8] = actionsOrder;
    $[9] = caption;
    $[10] = confirmingInstance;
    $[11] = instance;
    $[12] = isActivateOpen;
    $[13] = isCustomOpen;
    $[14] = isRemoveOpen;
    $[15] = isSettingsOpen;
    $[16] = rowId;
    $[17] = t;
    $[18] = testAttributePostfix;
    $[19] = actionSideElements;
    $[20] = t2;
  } else {
    actionSideElements = $[19];
    t2 = $[20];
  }
  const renderActions = t2;
  const thereAreActionsToRender = renderActions.length > 0;
  let t3;
  if ($[21] !== actionsTitle || $[22] !== instance) {
    t3 = actionsTitle?.(instance);
    $[21] = actionsTitle;
    $[22] = instance;
    $[23] = t3;
  } else {
    t3 = $[23];
  }
  const title = t3;
  const t4 = !thereAreActionsToRender && "invisible";
  let t5;
  if ($[24] !== t4) {
    t5 = twMerge("flex items-center", t4);
    $[24] = t4;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  let t6;
  if ($[26] !== t) {
    t6 = t("global.more_actions");
    $[26] = t;
    $[27] = t6;
  } else {
    t6 = $[27];
  }
  const t7 = !!testAttributePostfix;
  const t8 = `options-${rowId}`;
  let t9;
  if ($[28] !== t7 || $[29] !== t8) {
    t9 = getDataTestAttributes(t7, t8);
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== title) {
    t10 = title && <span className="block truncate">{title}</span>;
    $[31] = title;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== isFetching || $[34] !== renderActions || $[35] !== t10 || $[36] !== t6 || $[37] !== t9) {
    t11 = <ActionMenu ariaLabel={t6} isFetching={isFetching} dataTestAttributes={t9} drawerTitle={t10} menuItems={renderActions} />;
    $[33] = isFetching;
    $[34] = renderActions;
    $[35] = t10;
    $[36] = t6;
    $[37] = t9;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  let t12;
  if ($[39] !== actionSideElements || $[40] !== t11 || $[41] !== t5) {
    t12 = <div className={t5}>{t11}{actionSideElements}</div>;
    $[39] = actionSideElements;
    $[40] = t11;
    $[41] = t5;
    $[42] = t12;
  } else {
    t12 = $[42];
  }
  return t12;
}
function _temp2(item) {
  return Boolean(item);
}
function _temp(renderFunction) {
  return renderFunction();
}